import { Component, OnDestroy, OnInit, TemplateRef } from "@angular/core";
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { Socket } from "ngx-socket-io";
import { UsersService } from "../services/users.service";
import { Subject } from "rxjs";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { WalletCreateIdxComponent } from '../wallet-create-idx/wallet-create-idx.component';
import { Clipboard } from '@angular/cdk/clipboard';
import { CasinoProviderComponent } from "../casino-provider/casino-provider.component";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  providers: [HeaderComponent, FooterComponent, CasinoProviderComponent],
})
export class DashboardComponent implements OnInit, OnDestroy {
  offer_data: any;
  banner_img: any;
  marquetext: any;
  homeData: any;
  walletuser: any;
  dataLength: number;
  cricketData: any;
  soccerData: any;
  tennisData: any;
  kabbadiData: any;
  virtualCricketData: any;
  ballbyballData: any;
  moment: any = moment;
  inplay: any = false;
  selectedSportData: any;
  userDetails: any;
  virtuallog: boolean = false;
  kabbadilog: boolean = false;
  targetElement: Element;
  tokenCheck: boolean = false;
  avaialablePlayBattle: any;
  avaialableContest: any;
  gapcasino_menu: any;
  logo: any;
  currentUrl: string = '';
  createid: any;
  user: any;
  support: any;
  supportdata: any;
  support_nO: any;
  logintokenscreen: any;
  modalRefcancel: BsModalRef;
  aviatorArr: any;
  aviatorlog: any;
  ballArr: any;
  Contest_menu: any;
  playerbattle_menu: any;
  ballbycricket: any;
  wallet_status: any;
  myid: any;
  groupedData: any[] = [];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private socket: Socket,
    private clipboard: Clipboard,
    private usersService: UsersService,
    private modalService: BsModalService,
  ) {
    this.getBanner();

    this.route.params.subscribe((params) => {
      if (params.sportName === undefined) {
        if (sessionStorage.getItem("loginStatus") === "true") {
          // this.homeSoc();
          this.settings();
        } else {
          // this.homeFreeSoc();
          this.tokenCheck = true;
        }
      } else if (
        params.sportName === "inplay" &&
        sessionStorage.getItem("loginStatus") === "true"
      ) {
        this.Inplay();
        this.inplay = true;
        this.settings();

      }
    });

  }


  async getDetials() {
    try {
      const data = await JSON.parse(sessionStorage.getItem("userDetails"));
      this.avaialablePlayBattle = data?.details?.availableEventTypes.indexOf("3901");
      this.avaialableContest = data?.details?.availableEventTypes.indexOf("3902");

      return data;
    } catch (e) {
      return null;
    }
  }

  isInPlayRoute(): boolean {
    return this.router.url === '/dashboard/inplay';
  }
  isInPlaybatle(): boolean {
    return this.router.url === '/dashboard';
  }
  home() {
    this.router.navigate(["home"]);
  }

  async ngOnInit(): Promise<void> {
    this.homeSoc('none');
    this.getsupport()
    this.targetElement = document.querySelector("html");
    const usrDetails = await this.getDetials();
    this.user = usrDetails;
    this.currentUrl = this.router.url;
    if (this.user) {
      this.getcreateids();
    }

  }

  async settings() {
    this.userDetails = await this.getDetials();
    const data = { user_id: this.userDetails.details._id };

    this.usersService.SocketPost("menusetting", data).subscribe((res: any) => {
      var available_events = res;
      if (available_events) {
        // this.wallet_status=available_events?.manager?.wallet_status;
        var available_event = available_events.eventTypes;
        const available_user = available_events.user.availableEventTypes;

        // Map event types to menu variables
        const eventMap = {
          'b9': 'ballbycricket',
          'aviator': 'aviatorlog',
          'v9': 'virtuallog',
          '3902': 'Contest_menu',
          '3901': 'playerbattle_menu',
          '27979456': 'kabaddi_menu',
          'g9': 'gapcasino_menu',
        };

        // Initialize menu visibility
        Object.keys(eventMap).forEach((id) => {
          const menuKey = eventMap[id];
          const isEventAvailable = available_user.includes(id);
          const event = available_event.find((data) => data.eventType.id === id);
          // console.log(isEventAvailable);
          this[menuKey] = event?.visible_status && isEventAvailable;

        });
      }
    });
  }

  public cricket(section: string) {
    window.location.hash = '';
    window.location.hash = section;
  }

  openDialog2(myModal: TemplateRef<any>) {
    localStorage.setItem('firstVisit', 'result');
    this.modalRefcancel = this.modalService.show(
      myModal,
      Object.assign({}, { class: 'success modal-lg' })
    );
  }


  myRefreshEvent(event: Subject<any>, message: string) {
    setTimeout(() => {
      alert(message);
      event.next();
    }, 3000);
  }

  alert(message: string) {
    alert(message);
  }

  async Inplay() {

    this.userDetails = await this.getDetials();
    const data = { user_id: this.userDetails.details._id };
    this.usersService.SocketPost("get-inplay-markets", data).subscribe((res: any) => {
      if (res) {
        // sessionStorage.setItem(cacheKey3,JSON.stringify({ inplayMarkets: res, timestamp: Date.now() }));
        console.log(res.data);
        this.dataLength = res.data?.length;
        this.cricketData = [];
        this.soccerData = [];
        this.tennisData = [];
        this.kabbadiData = [];
        for (let i = 0; i < res.data?.length; i++) {
          const sortInplayFirst = (
            a: { marketBook: { inplay: boolean } },
            b: { marketBook: { inplay: boolean } }
          ) => {
            if (a.marketBook?.inplay === b.marketBook?.inplay) return 0;
            return a.marketBook?.inplay ? -1 : 1; // true first
          };

          if (res.data[i].eventTypeId == 4) {
            this.cricketData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('🏏 Cricket Data:', this.cricketData);
          } else if (res.data[i].eventTypeId == 1) {
            this.soccerData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('⚽ Soccer Data:', this.soccerData);
          } else if (res.data[i].eventTypeId == 2) {
            this.tennisData = res.data[i].markets.sort(sortInplayFirst);

          }
          else if (res.data[i].eventTypeId == 27979456) {
            this.kabbadiData = res.data[i].markets.sort(sortInplayFirst);

          }

        }
      }
      else {
        this.toastr.error(res.message, 'Error!');
      }
    });

  }

  checkVirtualShow() {
    if (
      this.virtualCricketData?.length &&
      this.virtualCricketData[0]?.managerStatus[
      this.userDetails.details.manager
      ] === true
    ) {
      return true;
    } else {
      return false;
    }
  }


  async homeSoc(id) {
    const cachedData = sessionStorage.getItem("cacheKey");

    if (cachedData) {
      const { markets, timestampB } = JSON.parse(cachedData);
      // Check if cache is still valid (5 minutes = 300,000 ms)
      if (Date.now() - timestampB < 60 * 1000) {
        this.processResponse(markets);
        return; // Use cached message
      } else {
        sessionStorage.removeItem('cacheKey'); // Clear expired cache
      }
    }

    // API call if no valid cache found
    const timestampMs = Date.now();
    const timestamp = 198728782826 * timestampMs;
    this.userDetails = await this.getDetials();
    let data
    if (this.userDetails == null) {
      data = {};
    } else {
      data = {
        user_id: this.userDetails.details._id,
        timestamp: timestamp,
        // ...(id !== "none" && { eventTypeId: id }) // Add eventTypeId only if provided
      };
    }

    this.usersService.SocketPost("get-market-eventTypeWise", data).subscribe((res: any) => {
      if (res) {
        var markets = res;
        // Save message to localStorage with timestamp
        sessionStorage.setItem("cacheKey", JSON.stringify({ markets: markets, timestampB: Date.now() }));
        this.processResponse(markets);
      }
    });
  }

  // Separate function to process and store response data
  processResponse(res) {
    this.dataLength = res.data.length;

    for (let i = 0; i < res.data.length; i++) {
      const sortInplayFirst = (
        a: { marketBook: { inplay: boolean } },
        b: { marketBook: { inplay: boolean } }
      ) => {
        if (a.marketBook?.inplay === b.marketBook?.inplay) return 0;
        return a.marketBook?.inplay ? -1 : 1;
      };

      const event = res.data[i];

      if (event.eventTypeId == 4) {
        this.cricketData = event.markets.sort(sortInplayFirst);
        // console.log('🏏 Cricket Data:', this.cricketData);
      } else if (event.eventTypeId == 1) {
        this.soccerData = event.markets.sort(sortInplayFirst);
        // console.log('⚽ Soccer Data:', this.soccerData);
      } else if (event.eventTypeId == 2) {
        this.tennisData = event.markets.sort(sortInplayFirst);
        // console.log('🎾 Tennis Data:', this.tennisData);
      }
      else if (event.eventTypeId == 27979456) {
        this.kabbadiData = event.markets.sort(sortInplayFirst);
        console.log('🎾 kabbadi Data:', this.kabbadiData);
      }
    }
  }
  async findHostName() {
    return window.location.hostname;
  }

  async getHost() {
    const hostname = await this.findHostName();
    const splithostname = hostname.split(".");
    this.logo = splithostname[0];
    this.setManager(splithostname[0]);
  }

  setManager(hostname: any) {
    if (hostname === "clubprt") {
      this.getOffer("PRTCLUB");
    } else if (hostname === "ferrariclubb") {
      this.getOffer("FERRARICLUB");
    } else if (hostname === "clubaob") {
      this.getOffer("AOBCLUB");
    } else if (hostname === "dlexch") {
      this.getOffer("DLCLUB");
    } else if (hostname === "fairbets247") {
      this.getOffer("FAIRBET");
    } else if (hostname === "clubosg") {
      this.getOffer("");
    } else if (hostname === "clubosg" || hostname === "dubaiclub247") {
      this.getOffer("OSGCLUB");
    } else if (hostname === "clublucky7") {
      this.getOffer("PRTLUCKY");
    }
    else if (hostname === "telegrambook") {
      this.getOffer("TELEGRAMBOOK");
    }
    else if (hostname === "kitbook") {
      this.getOffer("KITBOOK");
    }
    else {
      this.getOffer("OSGMANAGER");
    }
  }

  getBanner() {
    this.getHost();
    this.usersService.Get("get-banner/").subscribe((response: any) => {
      console.log(
        "🚀 ~ file: dashboard.component.ts:256 ~ DashboardComponent ~ this.usersService.Get ~ response:",
        response
      );

      this.banner_img = [];
      if (response.error) {
        this.toastr.error(response.message, "Error!");
      } else {
        this.banner_img = response.response;
      }
    });
  }

  getOffer(manager_name) {
    const data = { filter: { manager: manager_name, visible: true } };
    this.usersService
      .post_api("get-offer/", data)
      .subscribe((response: any) => {
        this.offer_data = [];
        if (response.error) {
          this.toastr.error(response.message, "Error!");
        } else {
          this.offer_data = response.data;
        }
      });
  }

  marqueText() {
    const data = {
      user: {
        _id: this.userDetails._id,
        key: this.userDetails.key,
        details: {
          username: this.userDetails.details.username,
          role: this.userDetails.details.role,
          status: this.userDetails.details.status,
        },
      },
    };
    // console.log(data);
    this.socket.emit("get-message", data);

    this.socket.on(
      "get-message-success",
      function (data: any) {
        // console.log(data);

        if (data) {
          // this.marquetext = data[0]?.message;
          this.marquetext = data?.message;
        }
      }.bind(this)
    );
  }



  goToDashboard(sportName, id, data) {
    if (id == -100) {
      this.router.navigate(["casino"]);
    } else if (id < -100) {
      this.router.navigate([
        "snova/" + id + "/" + data.name + "/" + data.providerCode,
      ]);
    } else {
      this.router.navigate(["dashboard/" + sportName]);
    }
  }

  checkInplayStatus(value): boolean {
    let CurrentDate = new Date();
    const currDate = CurrentDate.toISOString();
    if (currDate > value) {
      return true;
    } else {
      return false;
    }
  }

  openCasino(gameID: string) {
    const data = { gameId: gameID };
    localStorage.setItem('casinoDb', JSON.stringify(data));
    // this.route.navigate(['./casino-url']);
    this.router.navigate(["./casino-url"]);

  }

  openDaimond(gameID: string) {
    const data = { gameId: gameID };
    localStorage.setItem('casinoDb', JSON.stringify(data));
    // this.route.navigate(['./casino-url']);
    this.router.navigate(["./diamondtable-url"]);

  }



  matchDetail(eventId, eventTypeId) {
    this.router.navigate(["match-detail", eventId, eventTypeId]);
  }

  virtualDetial(eventId: any, eventTypeId: any) {
    this.router.navigate(["virtual-detail", eventId, eventTypeId]);
  }

  onClickofSport(sport) {
    this.selectedSportData = sport;
  }

  goToInplay(sportName) {
    this.router.navigate(["dashboard/" + sportName]);
  }
  hidehoure(date) {
    var enddate = new Date(date);
    enddate.setDate(enddate.getDate() + 1);
    const startdate = new Date();
    if (startdate < enddate) {
      return true;
    } else {
      return false;
    }
  }
  getmyid() {
    const data = {
      user_id: this.userDetails.details._id,
    }
    this.usersService.walletPost("getMysites", data).subscribe((response: any) => {
      // console.log(response);
      this.myid = response.data;
      let temp = [];
      for (let i = 0; i < this.myid.length; i += 2) {
        temp.push(this.myid.slice(i, i + 2)); // Create pairs of 2 items
      }
      this.groupedData = temp;

    })
  }
  gocreateid(id) {
    sessionStorage.setItem('createid', JSON.stringify(id))
    this.router.navigate(['create-id']);
  }
  gowithdraw(id, data) {
    sessionStorage.setItem('details', JSON.stringify(id))
    this.router.navigate(['deposite-withdraw/' + data]);
  }
  async copyToClip(value: string) {
    this.clipboard.copy(value);
    this.toastr.success("Copied !");

  };
  Ids(id) {
    if (id) {
      this.router.navigate(['wallet-idx', id]);
    }

  }
  getcreateids() {
    var data = { user_id: this.userDetails.details._id }
    this.usersService.walletPost("getSite", data).subscribe((response: any) => {
      //  console.log(response);
      this.createid = response.doc;


    })
  }


  async getsupport() {

    this.userDetails = await this.getDetials();
    // this.alert(JSON.stringify(this.userDetails?.details?._id));
    let data
    let domain = window.location.hostname;
    // let domain='clubosg.com';
    if (this.userDetails == null) {
      data = {
        loginStatus: false,
        domain: domain,
      }
    } else {
      data = {
        user_id: this.userDetails.details._id,
        loginStatus: true,
        domain: domain,
      }
    }
    this.supportData(data);


  }

  supportData(data: any) {
    this.usersService.SocketPost("get-support ", data).subscribe((res: any) => {
      if (res) {
        //  console.log(res);
        this.support = res.data;

      }
      else {
        // console.warn(res.message);
      }
    });
  }

  ngOnDestroy() {
    this.socket.removeAllListeners();
  }
}
